import script from "./uploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadFile.vue?vue&type=script&setup=true&lang=js"

import "./uploadFile.vue?vue&type=style&index=0&id=7a66463d&scoped=true&lang=scss"

import exportComponent from "H:\\03_微压氧舱-张赟\\共享氧舱\\爱尔威仕\\share-project-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a66463d"]])

export default __exports__